<template>
  <div>
    <t-row class="permissions-table-row">
      <t-column size="" class="permissions-table-row-header row-header-selector">All relationships {{ `(${totalRelationsCount})` }}</t-column>
      <t-column
        v-for="permittee in permissionsTablePermittees"
        :key="`all_relations_${permittee.client_id}`"
        size=""
        class="enable-all"
        :data-hover="`${permittee.client_id}`"
      >
        <row>
          <input
            :id="`enable_all_relation_permissions_${permittee.client_id}`"
            type="checkbox"
            @input="toggleAllPermissionsFor(permittee)"
            :checked="allPermissionsEnabledFor(permittee)"
            :indeterminate.prop="somePermissionsEnabledFor(permittee)"
          >
          <label :for="`enable_all_relation_permissions_${permittee.client_id}`">
            All
          </label>
        </row>
      </t-column>
      <t-column :class="`empty_cell`" v-for="index in remainingColumns" :key="`empty_header_${index}`" size="">
        <row>&nbsp;</row>
      </t-column>
    </t-row>
    <t-row class="permissions-table-row">
      <t-column size="" class="permissions-table-row-header row-header-selector">Record Holders</t-column>
      <t-column
        v-for="permittee in permissionsTablePermittees"
        :key="`record_holder_relations_${permittee.client_id}`"
        size=""
        :data-hover="`${permittee.client_id}`"
      >
        <row>
          <input
            :id="`enable_edit_record_holders_permissions_${permittee.client_id}`"
            type="checkbox"
            @input="createDestroyPermission(permittee, BuiltinPermissionObjectMap[objectModelBuiltinPermission.ConnectOrSeverRecordHolder], ObjectModelPermissionCapabilityType.ConnectOrSever)"
            :checked="!!permissionFor(permittee, BuiltinPermissionObjectMap[objectModelBuiltinPermission.ConnectOrSeverRecordHolder], ObjectModelPermissionCapabilityType.ConnectOrSever)"
          >
          <label :for="`enable_edit_record_holders_permissions_${permittee.client_id}`">
            Edit Record Holder
          </label>
        </row>
      </t-column>
      <t-column :class="`empty_cell`" v-for="index in remainingColumns" :key="`empty_header_${index}`" size="">
        <row>&nbsp;</row>
      </t-column>
    </t-row>
    <template v-for="relation in allRelations">
      <relation-row
        :key="relation.client_id"
        :relation="relation"
      ></relation-row>
    </template>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import selectedMixin from "../mixins/selectedMixin";
  import ObjectModelPermissionMixin from '../mixins/object-model-permission-mixin';
  import permissionTablePermitteesMixin from '../mixins/permission-table-permittees-mixin';
  import RelationRow from './view-permissions-section-workarea-table-relationship-row.vue';
  import {ObjectModelPermissionType} from "~/enums/objectModelPermissionType";
  import {ObjectModelActionType} from "~/enums/objectModelActionType";
  import remainingColumnMixin from "../mixins/remaining-column-mixin";
  import {gsap} from "gsap";
  // tslint:disable-next-line:no-submodule-imports
  import {ScrollTrigger} from "gsap/ScrollTrigger";
  import pluralizeable from "~/mixins/pluralizeable";
  import ObjectModelRelation from "~/models/objectModelRelations/objectModelRelation";
  import {ObjectModelRelationType} from "~/enums/objectModelRelationType";
  import {BuiltinPermissionObjectMap, objectModelBuiltinPermission} from "~/enums/objectModelBuiltinPermission";

  gsap.registerPlugin(ScrollTrigger);

  export default Vue.extend({
    mixins: [
      selectedMixin,
      ObjectModelPermissionMixin,
      pluralizeable,
      permissionTablePermitteesMixin,
      remainingColumnMixin
    ],
    components: {
      RelationRow,
    },
    data: (): object => {
      return {
        ObjectModelActionType,
        BuiltinPermissionObjectMap,
        objectModelBuiltinPermission
      };
    },
    computed: {
      permissionType(): ObjectModelPermissionType {
        return ObjectModelPermissionType.Relationship;
      },
      allRelations(): ObjectModelRelation[] {
        return this.selectedObjectModel.objectModelRelationsArray;
      },
      totalRelationsCount(): number {
        return this.allRelations.length;
      },
    },
    methods: {
      resetScrollTrigger(delay = 500): void {
        setTimeout(function(){ ScrollTrigger.refresh(); },delay);
      },
      accordionId(label:string): string {
        return label.replace(/\s+/g, '-').toLowerCase();
      }
    },
    mounted() {
      gsap.to("#panel-permissions .table-horizontal", {
        scrollTrigger: {
          id: "tableHeader",
          trigger: "#panel-permissions .table-header",
          pin: true,
          start: "top top",
          end: "bottom center",
          endTrigger: "#panel-permissions .table-horizontal",
          pinSpacing: false,
          scroller: "#panel-permissions .scroll-area",
        }
      })
    },
    destroyed() {
      ScrollTrigger.getById("tableHeader").kill(true);
    }
  });
</script>